<script lang="ts">

    export let src: string;
    export let autoplay: boolean = true;
    export let loop: boolean = true;

    let clientHeight: number;

</script>

<style lang="scss">

    .lottie-wrapper {
        height: 100%;
    }

</style>

<div class="lottie-wrapper" bind:clientHeight>
    {#if clientHeight}
        <lottie-player  {src} {autoplay} {loop}></lottie-player><!-- style="height: {clientHeight}px;" -->
    {/if}
</div>
